import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

class iconError extends Component {

  render() {
    const {
      className,
      size = 60
    } = this.props;

    const classes = '';

    return (
      <svg className={classNames(className, classes)} width={size} height={size} viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
        <title>Alert</title>
        <g fill="none" fillRule="evenodd">
          <path d="M30 0C13.43 0 0 13.43 0 30s13.43 30 30 30 30-13.43 30-30S46.57 0 30 0" fill="#FB543F"/>
          <path d="M33.333 13.333v9.954l-1.266 13.38h-4.084l-1.316-13.38v-9.954h6.666zm-6.626 33.334h6.626V40.04h-6.626v6.627z" fill="#FFF"/>
        </g>
      </svg>
    );
  }
}

iconError.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string
};

export default iconError;



/** WEBPACK FOOTER **
 ** ./client/components/Common/Error/IconError.jsx
 **/